import React, { useState } from 'react';
import { useHistory, useLocation, } from 'react-router-dom';
import { signIn, confirmSignIn } from "aws-amplify/auth";

import Button from '@mui/material/Button';

import Validate from "../utility/FormValidation";
import { Box, Paper, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import queryString from 'query-string';

import logo from './../../logos/Logo_Cerchio_1000px.svg'
import bgImage from '../../background/bgd_login.jpg'


export default function FirstLogin({ auth }) {

    const history = useHistory();
    const location = useLocation();
    const hashParams = queryString.parse(location.hash.replace('#', '?'));
    const locParams = hashParams.code ? hashParams : queryString.parse(location.search);

    const [credentialsForm, setCredentialsForm] = useState({
        params: locParams,
        email: decodeURIComponent(locParams.email || ''),
        password: '',
        confirmPassword: "",
        temporaryCode: "",
        showPassword: false,
        isLogging: false,
        errors: {
            email: "",
            password: "",
            confirmPassword: "",
            cognito: ""
        },
    });



    const handleSubmit = async () => {
        //event.preventDefault();
        //form validation

        setCredentialsForm({ ...credentialsForm, isLogging: true });
        // console.log('trying first login', credentialsForm.params.username, credentialsForm.params.code)
        // username in cognito non possono avere spazi
        // nell'uri i + vengono tradotti con spazi, allora viene ricodificato il +


        //VERSIONE VECCHIA AMPLIFY V4

        /* Auth.signIn(credentialsForm.params.username.replace(' ', '+'), credentialsForm.params.code)
            .then(user => {
                if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    // console.log('temp login done, new password reset ', credentialsForm.password)
                    Auth.completeNewPassword(user, credentialsForm.password)
                        .then(user_resetted => Auth.signIn(credentialsForm.email, credentialsForm.password))
                        .then(user_logged => auth.refreshAuthentication())
                        .then(() => {
                            //console.log('auth refreshd, now redirect')
                            setCredentialsForm({ ...credentialsForm, isLogging: false });
                            redirect('/dashboard');
                        })
                        .catch(error => {
                            console.log(error)
                            setCredentialsForm({
                                ...credentialsForm,
                                isLogging: false,
                                errors: {
                                    ...credentialsForm.errors,
                                    cognito: error.message || 'Unexpect error during authentication',
                                }
                            });
                        })
                }
            }) */

        //VERSIONE NUOVA AMPLIFY V6

        await signIn({ username: credentialsForm.params.username.replace(' ', '+'), password: credentialsForm.params.code })
            .then(async ({ isSignedIn, nextStep }) => {
                if (nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
                    await confirmSignIn({ challengeResponse: credentialsForm.password })
                        .then(async ({ isSignedIn, nextStep }) => {
                            if (isSignedIn) {
                                await auth.refreshAuthentication()
                                //console.log('auth refreshd, now redirect')
                                setCredentialsForm({ ...credentialsForm, isLogging: false });
                                redirect('/dashboard');
                            }
                        })
                        .catch((error) => {
                            console.error('Sign In error')
                            setCredentialsForm({
                                ...credentialsForm,
                                isLogging: false,
                                errors: {
                                    ...credentialsForm.errors,
                                    cognito: error.message || 'Unexpect error during authentication',
                                }
                            });
                        })

                }
            })
            .catch((error) => {
                console.error('Login error')
                setCredentialsForm({
                    ...credentialsForm,
                    isLogging: false,
                    errors: {
                        ...credentialsForm.errors,
                        cognito: error.message || 'Unexpect error during authentication',
                    }
                });
            })

    }


    const onInputChange = event => {
        const error = Validate({ ...credentialsForm, [event.target.id]: event.target.value });
        //console.log(error)
        setCredentialsForm({
            ...credentialsForm,
            [event.target.id]: event.target.value,
            errors: { ...credentialsForm.errors, ...error, cognito: null }
        });

    }

    const handleClickShowPassword = () => {
        setCredentialsForm({
            ...credentialsForm,
            showPassword: !credentialsForm.showPassword,
        });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const redirect = (dst) => {
        history.push(dst);
    }


    if (credentialsForm.params.email && credentialsForm.params.code && credentialsForm.params.username) {
        return (
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    overflow: 'hidden',
                    height: '100vh',
                    width: '100%',
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
                id='bg-container'
            >

                <Paper sx={{ width: '60%', minWidth: '23em', maxWidth: '40em', m: 'auto', marginTop: '8em', paddingTop: '2em' }} elevation={3}>
                    <Stack
                        component="form"
                        noValidate
                        autoComplete="new-password"
                        direction='column'
                        alignItems='center'
                    >

                        <img src={logo} height="100" alt="pagination logo" />

                        <Typography sx={{ m: '1em', marginBottom: '0.5em', marginTop: '2em' }} >
                            Please set a new password
                        </Typography>
                        <Typography variant='caption' sx={{ m: '1em', marginBottom: '2em', }}>
                            Password must have at least 8 characters, upper and lower case, a number.
                        </Typography>

                        <TextField
                            label="email"
                            id="email"
                            disabled
                            defaultValue={credentialsForm.params.email}
                            sx={{ m: 1, width: '80%', maxWidth: '30em' }}
                        />


                        <FormControl sx={{ m: 1, width: '80%', maxWidth: '30em' }} variant="outlined">
                            <InputLabel error={credentialsForm.errors.password !== ""}>
                                Password
                            </InputLabel>
                            <OutlinedInput
                                id="password"
                                label="password"
                                type={credentialsForm.showPassword ? 'text' : 'password'}
                                value={credentialsForm.password}
                                onChange={onInputChange}
                                error={credentialsForm.errors.password !== ""}
                                autoComplete="new-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            {credentialsForm.errors.password !== "" &&
                                <FormHelperText
                                    error={true}
                                    id="pass-err">
                                    {credentialsForm.errors.password}
                                </FormHelperText>
                            }
                        </FormControl>


                        <FormControl sx={{ m: 1, width: '80%', maxWidth: '30em' }} variant="outlined">
                            <InputLabel error={credentialsForm.errors.confirmPassword !== ""}>
                                Confirm password
                            </InputLabel>
                            <OutlinedInput
                                id="confirmPassword"
                                label="Confirm password"
                                type={credentialsForm.showPassword ? 'text' : 'password'}
                                value={credentialsForm.confirmPassword}
                                onChange={onInputChange}
                                error={credentialsForm.errors.confirmPassword !== ""}
                                autoComplete="new-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            {credentialsForm.errors.confirmPassword !== "" &&
                                <FormHelperText
                                    error={true}
                                    id="pass-err">
                                    {credentialsForm.errors.confirmPassword}
                                </FormHelperText>
                            }
                        </FormControl>


                        {credentialsForm.errors.cognito !== undefined &&
                            <Box id='cognito-error'>
                                <Typography variant='caption' color='error' sx={{ marginBottom: '1em' }}>
                                    {credentialsForm.errors.cognito}
                                </Typography>
                            </Box>
                        }


                        <Button
                            color="primary"
                            disabled={(credentialsForm.password === '' || credentialsForm.confirmPassword === '') || (credentialsForm.errors.email !== '' || credentialsForm.errors.password !== '' || credentialsForm.errors.confirmPassword !== '')}
                            loading={credentialsForm.isLogging}
                            //loadingPosition="start"
                            variant="contained"

                            onClick={handleSubmit}
                            sx={{ marginTop: '2em', marginBottom: '2em' }}
                        >
                            Login
                        </Button>



                    </Stack >
                </Paper>

            </Box>

        )
    }
    else {
        return null
    }


}


